import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { useDisabledDatePresets } from '@/App/tiles/shared/useDisabledDatePresets.tsx';
import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorPremiumDateData,
  selectTargetAccumulatorValidation,
} from '@/store/targetAccumulator/selectors.ts';

export function PremiumDate() {
  const tileId = useTargetAccumulatorTileId();
  const currencyPair = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.currencyPair);
  const disabledDatePresets = useDisabledDatePresets(tileId, currencyPair);

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const { premiumDate, premiumDateTenor } = useAppSelector((state) =>
    selectTargetAccumulatorPremiumDateData(state, tileId),
  );

  const handlePremiumPaymentDateSelected = (dateOrTenor: string) => {
    sgwtWebAnalytics?.trackEvent('TargetAccumulator', 'Premium payment date selected', dateOrTenor);

    checkTargetAccumulatorWithTradeCapture({
      premiumDate: dateOrTenor,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.premiumDate">
      <TradeCaptureValidationWrapper validation={validation?.premiumDate}>
        <DatePickerWithTenorNext
          data-e2e="premium-payment-date"
          date={premiumDate}
          tenor={premiumDateTenor}
          onChange={handlePremiumPaymentDateSelected}
          disablePresets={disabledDatePresets}
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
}
